import React, { FC } from "react";
import { clsx, Loader as Load } from "@mantine/core";

type Props = {
  page?: boolean;
  text?: string;
  card?: boolean;
};

const Loader: FC<Props> = ({ page, text, card }) => {
  return (
    <div
      className={clsx(
        "flex items-center justify-center flex-col",
        {
          "h-screen w-full": page,
          "h-64 w-full": card,
          "w-full h-full": !page && !card,
        }
      )}
    >
      <Load color={"green"} />
      {text}
    </div>
  );
};

export default Loader;
